import React from "react"

import { ColorSAP, Sandbox } from "../..//ontego-ui"
import Tooltip from "../Tooltip/Tooltip"
import { Box } from "@mui/material"

export const IconButton = (props) => {
    const { id, color = "primary", size = "small", disabled = false, icon = <Sandbox />, rootSx, textTooltip = "Tooltip", tooltipPlacement = "bottom", onClick = () => { }, withTooltip = true, ref } = props

    return (
        <Box
            sx={{ ...rootSx }}
        >
            <Tooltip
                title={textTooltip}
                placement={tooltipPlacement}
                disabled={!withTooltip || disabled}
            >
                <Box
                    id={id}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        transition: 'all .2s ease-in-out',
                        width: "32px",
                        height: "32px",
                        '& svg': {
                            width: "24px",
                            height: "24px",
                            pointerEvents: 'none',
                            transition: '0.25s color',
                            color: color === "primary" ? ColorSAP.primary[40] : ColorSAP.danger[40]
                        },
                        '&:hover': {
                            background: color === "primary" ? ColorSAP.primary[20] : ColorSAP.danger[10],
                            '& svg': {
                                color: color === "primary" ? ColorSAP.primary[70] : ColorSAP.danger[50]
                            },
                        },
                        '&:active': {
                            background: color === "primary" ? ColorSAP.primary[20] : ColorSAP.danger[10],
                            '& svg': {
                                color: color === "primary" ? ColorSAP.primary[100] : ColorSAP.danger[50]
                            }
                        }
                    }}
                    onClick={!disabled && onClick}
                    ref={ref}
                >
                    {icon}
                </Box>
            </Tooltip>
        </Box>
    )
}

export default React.memo(IconButton)